export default function TrustSection() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="mx-auto" style={{ maxWidth: 1200 }}>
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="lg:w-2/5">
            <span className="text-sm font-medium text-foreground-400">Trusted Shopping Directory</span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mt-3 mb-6">
              Transparency &amp; Safety Information
            </h2>
            <p className="text-foreground-600 leading-relaxed text-base">
              GTBuy Spreadsheet Hub operates as an independent comparison and directory platform. We curate and organize product category links that direct users to the main GTBuy sheet marketplace at kaspreadsheet.com. Our mission is to help shoppers navigate product categories efficiently while maintaining full transparency about our role as a directory service.
            </p>
          </div>

          <div className="lg:w-3/5 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {[
              { icon: 'ri-shield-check-line', title: 'We Do Not Sell Products', desc: 'GTBuy Hub is purely a directory. All product transactions happen on the main website.' },
              { icon: 'ri-bank-card-line', title: 'We Do Not Process Payments', desc: 'No payment information is ever collected or stored on this site.' },
              { icon: 'ri-external-link-line', title: 'External Links Are Third-Party', desc: 'All product links redirect to kaspreadsheet.com, an independent platform.' },
              { icon: 'ri-information-line', title: 'Use Information Responsibly', desc: 'Product availability and pricing may vary. Always verify on the main site.' },
            ].map((item) => (
              <div key={item.title} className="flex gap-4 p-5 bg-background-50 rounded-xl">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 flex-shrink-0">
                  <i className={`${item.icon} text-accent-700 text-lg`}></i>
                </div>
                <div>
                  <h4 className="font-semibold text-foreground-950 text-sm mb-1">{item.title}</h4>
                  <p className="text-foreground-500 text-sm leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-8 mt-16 pt-12 border-t border-background-200/70">
          {[
            { number: '14+', label: 'Product Categories' },
            { number: 'Daily', label: 'Sheet Updates' },
            { number: '100%', label: 'Free Access' },
            { number: '$0', label: 'Hidden Fees' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="font-heading text-4xl md:text-5xl font-bold text-foreground-950 mb-1">{stat.number}</div>
              <div className="text-sm text-foreground-500">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}